import React from 'react';
import { Box, Typography, Paper, Container, Chip } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';

function ChangeLog() {
  const changeLogEntries = [
                                            {
            
      date: '2026-4-13',
      changes: [
        'Futures table'
      ],
      type: 'feature'
    },
                                            {
            
      date: '2026-4-13',
      changes: [
        'Fixed event column data in projections export'
      ],
      type: 'bugfix'
    },
                                            {
            
      date: '2026-3-16',
      changes: [
        'Split out EV age into target age and sharp age'
      ],
      type: 'bugfeaturefix'
    },
                                        {
            
      date: '2026-3-16',
      changes: [
        'Fixed evtool bug where tracking a moneyline with hide market enabled would hide other unrelated moneylines'
      ],
      type: 'bugfix'
    },
                                        {
            
      date: '2026-3-14',
      changes: [
        'Volume data'
      ],
      type: 'feature'
    },
                                            {
            
      date: '2026-3-10',
      changes: [
        'Odds History popup enbaled across the app'
      ],
      type: 'feature'
    },
                                    {
            
      date: '2026-3-10',
      changes: [
        'New books - 1xbet,betway,codere,onyx odds,playdoit,sports interaction,sporttrade,stake,Unibet'
      ],
      type: 'feature'
    },
                                        {
            
      date: '2026-3-10',
      changes: [
        'New leagues - EPL,League 1,Bundasliga , Serie A, Liga MX, La Liga, MLS'
      ],
      type: 'feature'
    },
                                            {
            
      date: '2026-3-10',
      changes: [
        'Expanded Market Types'
      ],
      type: 'feature'
    },
                                                {
            
      date: '2026-3-10',
      changes: [
        'Unique deeplinks based on IOS/Android/Desktop and State/Country'
      ],
      type: 'feature'
    },
                                                    {
            
      date: '2026-3-10',
      changes: [
        'PrizePicks Multi-Leg deeplinks'
      ],
      type: 'feature'
    },

                                                        {
            
      date: '2026-3-10',
      changes: [
        'Bugfix on longstandding black screen crash on evtool page'
      ],
      type: 'bugfix'
    },

                                                            {
            
      date: '2026-3-10',
      changes: [
        'Updated BetTracker stats, improved automation of results grading'
      ],
      type: 'feature'
    },
    
                                    {
            
      date: '2025-12-23',
      changes: [
        'Conversions above 47 PRA were missing'
      ],
      type: 'bugfix'
    },
                                {
            
      date: '2025-12-23',
      changes: [
        'NBA results integrated into bettracker'
      ],
      type: 'feature'
    },
                            {
            
      date: '2025-12-09',
      changes: [
        'Cross line CLV'
      ],
      type: 'feature'
    },
                        {
            
      date: '2025-11-26',
      changes: [
        'Bet105, Kalshi, Polymarket'
      ],
      type: 'feature'
    },
                    {
            
      date: '2025-11-22',
      changes: [
        'Added new NFL bet types to results'
      ],
      type: 'improvement'
    },
                      {
         date: '2025-11-22',
      changes: [
        'Fixed Results data calculating non full game period types'
      ],
      type: 'bugfix'
    },
                     {
         date: '2025-11-22',
      changes: [
        'Fixed export columns in Results tab'
      ],
      type: 'bugfix'
    },
                     {
         date: '2025-11-21',
      changes: [
        'NFL Results V1'
      ],
      type: 'feature'
    },
                 {
         date: '2025-11-19',
      changes: [
        'Fixed IOS evtool crashes'
      ],
      type: 'bugfix'
    },
                 {
         date: '2025-11-19',
      changes: [
        'Fixed deeplinks opening to browser instead of app on IOS'
      ],
      type: 'bugfix'
    },
             {
         date: '2025-11-13',
      changes: [
        'Fixed non full game props not being tagged with period type'
      ],
      type: 'bugfix'
    },
                                                {
         date: '2025-11-11',
      changes: [
        'NBA Game Log modal support'
      ],
      type: 'feature'
    },
         {
         date: '2025-11-10',
      changes: [
        'Fixed not all additional odds being displayed on mobile'
      ],
      type: 'bugfix'
    },
     {
         date: '2025-11-06',
      changes: [
        'Fixed odds/props page filters not being saved '
      ],
      type: 'bugfix'
    },
                                                {
         date: '2025-11-06',
      changes: [
        'Fixed min ev setting where typing ".0" would reset the input '
      ],
      type: 'bugfix'
    },
                                            {
         date: '2025-11-06',
      changes: [
        'Min Growth setting in evtool'
      ],
      type: 'feature'
    },
                                            {
         date: '2025-11-03',
      changes: [
        'Initial CBB support'
      ],
      type: 'feature'
    },
                                            {
         date: '2025-11-01',
      changes: [
        'NFL game log modal added to Evtool and props screen'
      ],
      type: 'feature'
    },
                                        {
         date: '2025-10-28',
      changes: [
        'MVP of game log modals for NFL projections.'
      ],
      type: 'feature'
    },
                                    {
         date: '2025-10-21',
      changes: [
        'NBA market based projections are live'
      ],
      type: 'feature'
    },
                                {
         date: '2025-10-17',
      changes: [
        'Added conditional formatting to props/odds to reflect recency of line/price changes'
      ],
      type: 'feature'
    },
                                {
         date: '2025-10-17',
      changes: [
        'Resolved issue where order by book columns in props/odds were not consistent across bet types'
      ],
      type: 'bugfix'
    },
                            {
         date: '2025-10-10',
      changes: [
        'Resolved issue affecting BetMGM deeplinks'
      ],
      type: 'bugfix'
    },
    {
     date: '2025-10-09',
      changes: [
        'Added Middles Tool'
      ],
      type: 'feature'
    },
    {
     date: '2025-09-26',
      changes: [
        'Fixed bug causing arbitrage deeplinks not to display '
      ],
      type: 'bugfix'
    },
                        {
     date: '2025-09-25',
      changes: [
        'Added Sleeper and Underdog to pickem along with breakeven win % and EV. Prizepicks and Pick6 support for those fields coming at a later date. '
      ],
      type: 'feature'
    },
                    {
     date: '2025-09-25',
      changes: [
        'Improved accuracy of high end recieving yard converted projections'
      ],
      type: 'improvement'
    },
    {
      date: '2025-09-24',
      changes: [
        'Added period type filter to props screen. Added quarter period types to odds screen.'
      ],
      type: 'feature'
    },
              {
      date: '2025-09-22',
      changes: [
        'Added Summary bet type to Odds screen which displays Total and Spread in one view'
      ],
      type: 'feature'
    },
                {
            
      date: '2025-09-20',
      changes: [
        'Added deeplinks for Hard Rock, NoVig, Prophet Exchange, and Fanatics'
      ],
      type: 'improvement'
    },
          {
      date: '2025-09-18',
      changes: [
        'Search functionality implemented on projections page'
      ],
      type: 'feature'
    },
            {
            
      date: '2025-09-17',
      changes: [
        'Pass Attempts, Completions, and Rush Attempts added to market based projections'
      ],
      type: 'improvement'
    },
        {
            
      date: '2025-09-15',
      changes: [
        'Pinnacle added to arbitrage tool'
      ],
      type: 'improvement'
    },
      {
      date: '2025-09-13',
      changes: [
        'Projections page now supports college football'
      ],
      type: 'feature'
    },
    {
      date: '2025-09-12',
      changes: [
        'Impoved cross line conversion algorithms for recieving yards and rushing yards. Rushing yards has another update coming soon'
      ],
      type: 'improvement'
    },
    {
      date: '2025-09-11',
      changes: [
        'Impoved cross line conversion algorithms for receptions'
      ],
      type: 'improvement'
    },
    {
      date: '2025-09-10',
      changes: [
        'Fixed growth column display issues for smaller resolutions'
      ],
      type: 'bugfix'
    },
    {
      date: '2025-09-09',
      changes: [
        'Implemented mean conversion algorithms for total touchdowns - now with all stats covered PPR and Half PPR projections are being displayed on the projections tab',
      ],
      type: 'feature'
    },

  ];

  const getTypeColor = (type) => {
    switch (type) {
      case 'feature':
        return '#4caf50';
      case 'improvement':
        return '#2196f3';
      case 'bugfix':
        return '#ff9800';
      default:
        return '#9e9e9e';
    }
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case 'feature':
        return 'New Feature';
      case 'improvement':
        return 'Improvement';
      case 'bugfix':
        return 'Bug Fix';
      default:
        return 'Update';
    }
  };

  return (
    <Box
      sx={{
        height: 'calc(100vh - var(--connection-panel-height, 48px))',
        overflow: 'auto',
        backgroundColor: '#121212',
      }}
    >
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Paper sx={{ p: 3, backgroundColor: '#1e1e1e', color: '#ffffff' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <HistoryIcon sx={{ mr: 2, fontSize: 28, color: '#4fc3f7' }} />
            <Typography variant="h4" component="h1">
              Change Log
            </Typography>
          </Box>
          
          <Typography variant="body1" sx={{ mb: 4, color: '#bbbbbb' }}>
            Track the latest updates, improvements, and bug fixes to SharpStack.
          </Typography>

          {changeLogEntries.map((entry, index) => (
            <Box 
              key={index} 
              sx={{ 
                mb: 4, 
                pb: 3, 
                borderBottom: index < changeLogEntries.length - 1 ? '1px solid #444' : 'none' 
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 2 }}>
                <Typography variant="h6" sx={{ color: '#ffffff' }}>
                  {new Date(entry.date + 'T00:00:00').toLocaleDateString('en-US', { 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                  })}
                </Typography>
                <Chip 
                  label={getTypeLabel(entry.type)} 
                  size="small" 
                  sx={{ 
                    backgroundColor: getTypeColor(entry.type),
                    color: '#ffffff',
                    fontWeight: 'bold'
                  }} 
                />
              </Box>
              
              <Box component="ul" sx={{ 
                mt: 2,
                pl: 3,
                '& li': { 
                  mb: 1, 
                  color: '#e0e0e0',
                  lineHeight: 1.6
                }
              }}>
                {entry.changes.map((change, changeIndex) => (
                  <li key={changeIndex}>{change}</li>
                ))}
              </Box>
            </Box>
          ))}

          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #444' }}>
            <Typography variant="body2" sx={{ color: '#999999' }}>
              Have feedback or suggestions? Join our{' '}
              <a 
                href="https://discord.gg/4for4" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: '#4fc3f7', textDecoration: 'none' }}
              >
                Discord
              </a>
              {' '}and let us know in the #sharpstack-chat channel.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default ChangeLog;